<div class="main global-table-wrapper">
    <div class="title-btn">
        <div class="main-title">
            <h1>AuditLog List</h1>
            <p>Show your AuditLog list information</p>
        </div>
    </div>

    <app-search-filter
        [config]="filterConfig"
        (filter)="onCustomFilter($event)"
        (clear)="onCustomFilterClear()"
    ></app-search-filter>

    <p-table
        [value]="auditlogList"
        responsiveLayout="scroll"
        [loading]="loading"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>EntityName</th>
                <th>EntityId</th>
                <th>ActionType</th>
                <th>IP Address</th>
                <th>Status</th>
                <th>UpdatedOn</th>
                <th>UpdatedBy</th>
                <th>View</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr class="text-break">
                <td>{{ item.entityName }}</td>
                <td>{{ item.entityId }}</td>
                <td>{{ item.actionType }}</td>
                <td>{{ item.ipAddress }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.updatedOn | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.updatedByUser }}</td>
                <td>
                    <a
                        class="table-action-icon"
                        [routerLink]="['/audilog-detail', item.id]"
                        pTooltip="AuditLog Detail"
                        tooltipPosition="top"
                        ><i class="fa fa-eye"></i
                    ></a>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div *ngIf="isPaginator">
        <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            (onPageChange)="onPageChange($event)"
        ></p-paginator>
    </div>
</div>
